import React, { useEffect, useState } from 'react';

import * as libCon from '../community-hats-js-library/Constants';
import * as locCon from '../LocalConstants';
import { RefATOField, setStoredValue, StateStoredBooleanValue } from '../hooks/StoreHooks';

import { showErrorDialogByCode } from '../utils/dialogFunctions';
import { testGoogleHealthApiForEmail } from '../community-hats-js-library/back-end/router';
import CustomText from '../elements/CustomText';
import CustomSpin from '../elements/CustomSpin';
import { CustomPrimaryButtonWithDisability } from '../elements/CustomButton';
import { isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions';
import { RefContextLanguage } from '../providers/LanguageProvider';

// The counterpart of TestFitibitApiButton, and identical to it in shape.
//
// Both send an email address and nothing else. The token stays on the server,
// which looks it up, refreshes it if it has gone stale, and answers only
// whether the grant works. That refresh is the reason this cannot be done in
// the browser: a Google access token lives about an hour, so a check against a
// token the browser is holding starts failing an hour after linking.
export function TestGoogleHealthApiButton({ checkboxId = null }) {
  const i18n = RefContextLanguage();

  const email = RefATOField(locCon.AT_OBJECT_EMAIL_ACCOUNT, libCon.ATF_EMAIL);

  const [apiOk, setApiOk] = StateStoredBooleanValue(locCon.GOOGLE_HEALTH_API_OK);

  const [testing, setTesting] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [warningText, setWarningText] = useState(() => null);

  useEffect(() => {
    if (isNullOrUndefined(email)) {
      setDisabled(true);
      setWarningText(libCon.ATF_EMAIL);
      setApiOk(false);
    } else setDisabled(false);
  }, [email, setApiOk]);

  const testApi = async () => {
    setTesting(true);

    const code = await testGoogleHealthApiForEmail(email);

    if (code === libCon.OK) {
      setApiOk(true);
      setStoredValue(checkboxId, true);
    } else {
      showErrorDialogByCode(code);
      setStoredValue(checkboxId, false);
    }

    setTesting(false);
  };

  return (
    <div className="verticalSection">
      {apiOk === true ? (
        <CustomText type={locCon.ELEMENT_TEXT}>{i18n.t('successGoogleHealthAPI')}</CustomText>
      ) : testing === true ? (
        <CustomSpin type={locCon.BUTTON_SPINNER} />
      ) : (
        <CustomPrimaryButtonWithDisability
          isDisabled={disabled}
          title={i18n.t('missingValues')}
          description={warningText}
          onClick={() => testApi()}
        >
          {i18n.t('testApi')}
        </CustomPrimaryButtonWithDisability>
      )}
    </div>
  );
}

export default TestGoogleHealthApiButton;
